/**
 * SAM-1171 (Security, condition 1): a second click on Confirm while the first create is still running must do
 * nothing. The flag is a ref flipped synchronously on the first line, before any await, so it holds even when React
 * has not re-rendered the disabled button yet; it is released when the create settles, success or failure.
 */
export const runIfIdle = async (flag: { current: boolean }, task: () => Promise<unknown>): Promise<void> => {
  if (flag.current) return;
  flag.current = true;
  try {
    await task();
  } finally {
    flag.current = false;
  }
};
